<template >
  <div class="player-box" >
    <Nav :showMobileSearch="false" style="display:none;" ref="Nav" /><!--播放组件 未登录状态下，点击收藏按钮弹框使用 chenss20221014-->
    <div :class="showList ? 'song-list cur' : 'song-list'">
      <div class="song-box">
        <div class="tit">
          <span
            >最近播放({{ audioList.length }})<b
              class="clear-list"
              @click="clearList"
              v-if="audioList.length > 0"
              >清空列表</b
            ></span
          >
          <span @click="showList = !showList">收起</span>
        </div>
        <!--
        <div class="list">
          <div v-for="(item,aIndex) in audioList" :key="'audioList'+aIndex" :class="aIndex===playIndex?'song cur':'song'">
            <div @click="changeAudio(aIndex)" v-if="item.name">
              <i></i>{{item.name}}<span v-if="item.isTry">[试听]</span>
            </div>
            <a href="javascript:" class="delete" @click="handleDelete(aIndex)"></a>
          </div>
        </div>
        -->
        <div class="list">
          <div
            v-for="(item, index) in audioList"
            :key="item.url"
            :class="index === playIndex ? 'song cur' : 'song'"
          >
            <div @click="changeAudio(index)">
              <i></i>{{ item.name | ellipsis
              }}<span v-if="item.isTry">[试听]</span>
            </div>
            <a
              href="javascript:"
              class="delete"
              @click="handleDelete(index)"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div :class="getPlayerClass()">
      <div class="player-ui">
        <router-link
          :to="
            '/song-detail/' + encodeURIComponent(audioList[playIndex]['singer'])
          "
          class="name"
          v-if="audioList.length > 0"
        >
          {{ audio.name || "暂无曲目" }}
        </router-link>
        <div class="play-button">
          <span
            class="play-pc-hide"
            :class="isPlay ? 'pause' : 'play'"
            @click="play"
            v-if="!showList && audioList.length > 0"
          ></span>
          <div class="player-info" :class="showList ? '' : 'short-width'">
            <span class="played-time">{{
              audioList.length > 0 ? playedTime : ""
            }}</span>
            <div class="p-box" v-if="audioList.length > 0">
              <aplayer
                ref="player"
                :audio="audio"
                :list="audioList"
                :lrcType="3"
                :customAudioType="customAudioType"
                @playing="playing"
                @canplay="canplay"
                @timeupdate="handleEvent()"
              />
            </div>
            <span class="count-time">{{
              audioList.length > 0 ? countTime : ""
            }}</span>
          </div>
        </div>
      </div>
      <div :class="showList ? 'player-ctrl cur' : 'player-ctrl'">
        <span :class="'mode' + playMode" @click="changeMode"></span>
        <span class="prev" @click="handlePrev"></span>
        <span :class="isPlay ? 'pause' : 'play'" @click="play"></span>
        <span class="next" @click="handleNext"></span>
        <span
          :class="currentAudio['isFavorite'] ? 'fav cur' : 'fav'"
          @click="handleFav()"
        ></span>
      </div>
      <div
        :class="showList ? 'show-list cur' : 'show-list'"
        @click="showList = !showList"
      >
        <i></i><span>播放列表</span>
      </div>
    </div>
    <a-modal
      title="播放，仅剩一步"
      :visible="visible"
      @ok="handleOk"
      :footer="null"
      @cancel="handleCancel"
    >
      <p>您还未登录，暂无播放权限。 点击登录后即可畅听 ：)</p>
      <div class="modal-btn">
        <a href="javascript:" class="cancel" @click="handleCancel">取消</a>
        <a href="javascript:" class="confirm" @click="handleOk">去登录</a>
      </div>
    </a-modal>
  </div>
</template>
<script>
import Hls from "hls.js";
import _ from "lodash/lodash";
import {
  musicList,
  collFav,
  ncollFav,
  whiteIpList,
  userIpInfo
} from "@/api";
import Nav from "@/components/nav";
import { userInfo } from "os";
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
  navigator.userAgent
);
export default {
  components: {
    Nav
  },
  data() {
    return {
      customAudioType: {
        customHls(audioElement, audio, player) {
          if (Hls.isSupported()) {
            const hls = new Hls();
            hls.loadSource(audio.url);
            hls.attachMedia(audioElement);
          } else if (
            audioElement.canPlayType("application/x-mpegURL") ||
            audioElement.canPlayType("application/vnd.apple.mpegURL")
          ) {
            audioElement.src = audio.url;
          } else {
            player.showNotice("Error: HLS is not supported.");
          }
        },
      },
      scgq: [],
      isFav: false,
      getAudioUrl: "https://img.library.sh.cn/hisdata/cp/audio/",
      playedTime: "00:00",
      countTime: "00:00",
      timer: null,
      isPlay: false,
      playIndex: 0,
      isMobile,
      showList: false,
      isLogin: false,
      playMode: 1,
      visible: false,
      audioList: [],
      sjzb: [],
      whiteIpFlag: false //免登陆播放白名单标记 true:是，flase:否 chenss 20221014
    };
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (isMobile) {
        if (value.length > 35) {
          return value.slice(0, 35) + "...";
        }
      } else {
        if (value.length > 200) {
          return value.slice(0, 200) + "...";
        }
      }
      return value;
    },
  },
  computed: {
    currentAudio() {
      if (
        this.audioList.length &&
        this.playIndex >= 0 &&
        this.playIndex < this.audioList.length
      ) {
        return this.audioList[this.playIndex];
      } else {
        return {
          name: "",
        };
      }
    },
    audio() {
      // //console.log('computed audio')
      if (
        this.audioList.length &&
        this.playIndex >= 0 &&
        this.playIndex < this.audioList.length
      ) {
        return {
          singer: this.audioList[this.playIndex]["singer"],
          name: this.audioList[this.playIndex]["name"],
          artist: this.audioList[this.playIndex]["artist"],
          url: this.audioList[this.playIndex]["url"],
          type: "customHls",
          // 注释此行代码，会导致收藏时重新播放
          // isFavorite:this.audioList[this.playIndex]['isFavorite']
        };
      } else {
        return {
          name: "",
          artist: "",
          url: "",
          type: "customHls",
          // 注释此行代码，会导致收藏时重新播放
          // isFavorite:false,
          singer: "",
        };
      }
    },
  },
  mounted() {
    this.loadPlayList();
    this.InitWhiteIpFlag();//进入画面则加载是否为免登录白名单判断方法 chenss20221014
  },
  methods: {
    //清空列表
    clearList() {
      this.audioList = [];
      this.savePlayList();
      //清空列表后，1秒自动隐藏曲目单弹框
      setTimeout(() => {
        this.showList = !this.showList;
      }, 1000);
    },
    async InitWhiteIpFlag(){//判断登录用户是否为白名单用户 
      this.whiteIpFlag =false;//默认非免登录
      const res =  await whiteIpList();//ip白名单，在此列表中的ip,无需登录也能播放唱片和音乐 chenss20221014
      if(this.GLOBAL.BASE_IP_INFO=='' || this.GLOBAL.BASE_IP_INFO.ip==''){//如果有IP加载为空的情况，则重新获取用户IP一次
        const resIp = await userIpInfo();
        const result = resIp;
        this.GLOBAL.BASE_IP_INFO=result.data;
        // console.log("重新获取用户IP:"+this.GLOBAL.BASE_IP_INFO.ip);
      }
      var iplists = "10.6.152.160,10.6.152.173,10.6.152.96,10.6.152.1,10.6.152.213,10.6.152.41,10.6.152.103,10.6.152.44,10.6.152.170,10.6.152.202,10.1.188.165,10.1.55.133,10.1.189.186,10.1.188.238,10.1.55.133,10.1.189.26"
      //  var ipList = (res && res.data) ? res.data.split(','):[]; chenss 20241212 防止泄露
      var ipList = iplists.split(',');
      //不存在：-1
      if(ipList.findIndex(item => item === this.GLOBAL.BASE_IP_INFO.ip)>=0){
        this.whiteIpFlag =true;//存在则为白名单
      }
    
    },
    // 加载播放列表
    loadPlayList() {
      this.playMode = localStorage.getItem("playMode")
        ? parseInt(localStorage.getItem("playMode"))
        : 1;
      var list = [];
      if (
        localStorage.getItem("token") &&
        localStorage.getItem("token") != ""
      ) {
        if (
          localStorage.getItem("playerList") &&
          JSON.parse(localStorage.getItem("playerList"))
        ) {
          const hisPly = JSON.parse(localStorage.getItem("playerList"));
          this.audioList = hisPly;
          if (this.audioList.length > 0) {
            this.isFav = this.audioList[this.playIndex]["isFavorite"];
          }
        }
      }

      this.playIndex = localStorage.getItem("playIndex")
        ? parseInt(localStorage.getItem("playIndex"))
        : 0;
      //判断播放状态和播放列表是否有数据
      if (
        localStorage.getItem("isPlay") &&
        localStorage.getItem("isPlay") == "1" &&
        this.audioList.length > 0
      ) {
        this.$nextTick(() => {
          const player = this.$refs.player;
          this.isPlay = true;
          setTimeout(() => {
            this.countTime = this.reformat_time(player.media.duration);
            this.playedTime = this.reformat_time(
              localStorage.getItem("playedTime")
            );
            player.seek(localStorage.getItem("playedTime"));
            player.play();
            this.timer = setInterval(() => {
              this.playedTime = this.reformat_time(player.media.currentTime);
            }, 500);
          }, 500);
        });
      } else if (
        localStorage.getItem("isPlay") &&
        localStorage.getItem("isPlay") == "2" &&
        this.audioList.length > 0
      ) {
        this.$nextTick(() => {
          const player = this.$refs.player;

          this.isPlay = false;
          setTimeout(() => {
            this.countTime = this.reformat_time(player.media.duration);
            this.playedTime = this.reformat_time(
              localStorage.getItem("playedTime")
            );
            player.seek(localStorage.getItem("playedTime"));
          }, 500);
        });
      }
      this.audioList.forEach((item, index) => {
        this.sjzb.push(index);
      });
      this.sjzb = _.shuffle(this.sjzb);
      //console.log(this.sjzb);
    },
    //开始播放后刷新总时长（配合切换使用）
    playing() {
      const player = this.$refs.player;
      this.countTime = this.reformat_time(player.media.duration);
    },
    handleEvent() {
      if (this.playMode === 1) {
        const player = this.$refs.player;
        if (player.media.duration == player.media.currentTime) {
          player.pause();
          this.handleNext();
        }
      }
      if (this.playMode === 2) {
        const player = this.$refs.player;
        if (player.media.duration == player.media.currentTime) {
          player.pause();
          this.changeAudio(this.getshuffle());
        }
      }
    },
    // 保存播放列表
    savePlayList() {
      localStorage.setItem("playerList", JSON.stringify(this.audioList));
    },
    // 刷新播放时间
    startRefreshPlayerTime() {
      const player = this.$refs.player;
      if (!player) {
        this.countTime = this.reformat_time(0);
        this.playedTime = this.reformat_time(0);
        return;
      }
      if (!this.timer) {
        clearInterval(this.timer);
      }
      this.countTime = this.reformat_time(player.media.duration);
      this.timer = setInterval(() => {
        this.playedTime = this.reformat_time(player.media.currentTime);
      }, 500);
    },
    //播放器加载完成时初始化播放开始时间
    canplay() {
      const player = this.$refs.player;
      this.countTime = this.reformat_time(player.media.duration);
    },
    // 停止
    stopPlayer() {
      if (!this.timer) {
        clearInterval(this.timer);
      }

      const player = this.$refs.player;
      if (!player) {
        this.countTime = this.reformat_time(0);
        this.playedTime = this.reformat_time(0);
        return;
      }
      player.pause();
      this.countTime = this.reformat_time(player.media.duration);
      this.playedTime = this.reformat_time(0);
      this.isPlay = false;
    },
    // 获取曲目Index
    getAudioIndex(url) {
      const _this = this;
      if (!_this.audioList || !_this.audioList.length) {
        return;
      }
      var audioIndex = -1;
      //console.log(this.audioList)
      this.audioList.forEach((item, index) => {
        if (item.url === url) {
          this.audioList.splice(index, 1);
        }
      });
    },
    //播放栏收藏
    async handleFav() {
      if ( //未登录时 提示先登录 再收藏 new add chenss 20221014 
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == ""
      ) {
        this.$refs.Nav.showTk(2);
        return;
      }
      const res = this.audioList[this.playIndex].isFavorite
        ? await ncollFav({ uri: this.audioList[this.playIndex]["singer"] })
        : await collFav({ uri: this.audioList[this.playIndex]["singer"] });
      this.$emit("saveFav", this.audioList[this.playIndex]);

      this.audioList[this.playIndex].isFavorite =
        !this.audioList[this.playIndex].isFavorite;
      this.savePlayList();

      this.$message.open({
        content: this.audioList[this.playIndex].isFavorite
          ? "已收藏"
          : "已取消收藏",
        icon: (
          <img
            style="width:14px;height:14px;margin-right:5px"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEUSURBVHgBpZFNbsIwEIVnvEBZplL/dqUnqHqD3qDpBsyuPUF7g6Q3oCeougOvygm4AtwgOyQiBFsEzDC2CAo/gZA8yYn9xv409kPIaBoE/sLzAiR6UIgzGb2rTie2tZHW9RrzKzH7BDCsKTVIa1aYTsat1pciChnAh121ZROK/5k1xYuXzD/3xrS3oLHW78j8CyUkHb7dGfOv7EIxh1BSAnANYKL1CzD3oYLmRM9K7l6HivIQnxSsVgOoKGaO3WMnzeYUDtMqBpH0brvdR/fYktgHlJQEFbm//Vzb+DbGZe1wJGf/XDNZf9JohIQYFYXcGPOdLnG/Xgi2BzkKOgs7AskF5cJyICdBB7ATkEKysETGuX1rfziAH44aflAAAAAASUVORK5CYII="
          />
        ),
      });
    },
    //播放模式
    changeMode() {
      if (this.playMode === 1) {
        this.playMode = 2;
      } else if (this.playMode === 2) {
        this.playMode = 3;
      } else if (this.playMode === 3) {
        this.playMode = 1;
      }
      localStorage.setItem("playMode", this.playMode);
    },
    //整合播放数据
    getAduioData(list) {
      const audioListN = this.audioList.length;
      //替换播放源地址
      list.forEach((item, index) => {
        if (audioListN == 0) {
          item["url"] =
            "https://img.library.sh.cn/dy/audio/" +
            item["url"].slice(0, -4) +
            "/audio.m3u8";
        } else {
          list[list.length - 1 - index]["url"] =
            "https://img.library.sh.cn/dy/audio/" +
            list[list.length - 1 - index]["url"].slice(0, -4) +
            "/audio.m3u8";
        }
      });
      if (!list.length) {
        return;
      }
      //console.log(list);
      const _this = this;
      list.forEach((item, index) => {
        let objMusic = {
          name: list[list.length - 1 - index]["name"],
          artist: list[list.length - 1 - index]["artist"],
          singer: list[list.length - 1 - index]["singer"],
          url: list[list.length - 1 - index]["url"],
          isTry: false,
          isFavorite: list[list.length - 1 - index]["isFavorite"],
        };
        this.getAudioIndex(objMusic.url);
        this.audioList.unshift(objMusic);
      });
      this.audioList.splice(100, this.audioList.length - 100);

      const sjzbData = [];
      this.audioList.forEach((item, index) => {
        sjzbData.push(index);
      });
      this.sjzb = _.shuffle(sjzbData);
    },
    //跳转路由前刷新播放初始数据
    savePlayer() {
      if (this.audioList.length > 0) {
        const player = this.$refs.player;
        localStorage.setItem("playedTime", player.media.currentTime);
        localStorage.setItem("playIndex", this.playIndex);
        localStorage.setItem("isPlay", this.isPlay ? "1" : 2);
        localStorage.setItem("playModel", this.playModel);
      }
    },
    //修改播放状态栏中数据收藏状态
    saveFav(item) {
      this.audioList.forEach((i, k) => {
        if (i["singer"] == item["@id"]) {
          this.audioList[k]["isFavorite"] = item["isFavorite"];
        }
      });
      this.savePlayList();
    },
    //根据API返回数据，封装为播放列表结构数据
    buildPlayList(result) {
      let songData = [];
      let apiData = result;
      if (apiData instanceof Array) {
        apiData.forEach((k, v) => {
          if (k["audio"]) {
            songData.push({
              name: k["dctitle"]["@value"],
              artist: k["@id"],
              singer: k["@id"],
              url: k["audio"]["label"],
              isTry: false,
              isFavorite: k["isFavorite"],
            });
          }
        });
      } else {
        songData.push({
          name: apiData["dctitle"]["@value"]
            ? apiData["dctitle"]["@value"]
            : "",
          artist: apiData["@id"],
          singer: apiData["@id"],
          url: apiData["audio"]["label"],
          isTry: false,
          isFavorite: apiData["isFavorite"],
        });
      }
      return songData;
    },
    //执行添加操作
    addList(list) {
      this.getAduioData(list);
      this.currentTime = "00:00";
      this.savePlayList();
      this.$nextTick(() => {
        const player = this.$refs.player;
        this.playIndex = 0;
        this.isPlay = true;
        clearInterval(this.timer);
        setTimeout(() => {
          player.play();
          this.isPlay = true;
          this.countTime = this.reformat_time(player.media.duration);
          this.timer = setInterval(() => {
            this.playedTime = this.reformat_time(player.media.currentTime);
          }, 500);
        }, 100);
      });
    },
    // 播放/暂停
    play() {
      const player = this.$refs.player;
      if (!player) {
        this.countTime = this.reformat_time(0);
        this.playedTime = this.reformat_time(0);
        return;
      }
      if (player.media.paused) {
        player.play();
        this.isPlay = true;
        this.countTime = this.reformat_time(player.media.duration);
        this.startRefreshPlayerTime();
      } else {
        player.pause();
        clearInterval(this.timer);
        this.isPlay = false;
      }
      localStorage.setItem("playedTime", player.media.currentTime);
      localStorage.setItem("isPlay", this.isPlay ? "1" : 2);
    },
    playSingleSong(that, item) {
      // alert(this.whiteIpFlag);
      if(!this.whiteIpFlag){//如果不是白名单，则依然走登录判断逻辑 chenss 20221014
          if (
          !localStorage.getItem("token") ||
          localStorage.getItem("token") == ""
        ) {
          that.showTk(1);
          return;
        }
      }
      
      // if (
      //     !localStorage.getItem("token") ||
      //     localStorage.getItem("token") == ""
      //   ) {
      //     that.showTk(1);
      //     return;
      //   }
      let songData = [];
      console.log(item["playable"]);

      if (!item["playable"]) {
        that.showTk(4);//该曲目无法播放
        return;
      }
      songData.push({
        name: item["dctitle"]["@value"] ? item["dctitle"]["@value"] : "",
        artist: item["@id"],
        singer: item["@id"],
        url: item["audio"]["label"],
        isTry: false,
        isFavorite: item["isFavorite"],
      });
      if (songData.length <= 0) {
       that.showTk(4);//该曲目无法播放
        return;
      }
      this.$emit("curPlay", 1);
      this.addList(songData);
    },
    async playSong(that, item) {
      if(!this.whiteIpFlag){//如果不是白名单，则依然走登录判断逻辑 chenss 20221014
          if (
          !localStorage.getItem("token") ||
          localStorage.getItem("token") == ""
        ) {
          that.showTk(1);
          return;
        }
      }
      // if (
      //     !localStorage.getItem("token") ||
      //     localStorage.getItem("token") == ""
      //   ) {
      //     that.showTk(1);
      //     return;
      //   }
      if (!item["playable"]) {
        that.showTk(3);
        return;
      }
      let res = await musicList({
        field: "RECORD",
        value: item["@id"],
        pageSize: 100,
      });
      let result = res.data.datas;

      if (result.length <= 0) {
        that.showTk(3);
        return;
      }
      let songData = [];

      songData = this.buildPlayList(result);

      this.$emit("curPlay", 1);
      this.addList(songData);
    },
    reformat_time(time) {
      const a = parseInt(time);
      if (a < 10) {
        return "00:0" + a;
      } else if (a > 9 && a < 60) {
        return "00:" + a;
      } else if (a > 59) {
        return (
          (Math.floor(a / 60) > 9
            ? Math.floor(a / 60)
            : "0" + Math.floor(a / 60)) +
          ":" +
          (a % 60 > 9 ? a % 60 : "0" + (a % 60))
        );
      }
    },
    //指定播放
    changeAudio(index) {
      const player = this.$refs.player;
      this.isPlay = true;
      player.switch(index);
      player.play();
      this.playIndex = index;
      setTimeout(() => {
        this.countTime = this.reformat_time(player.media.duration);
        //this.startRefreshPlayerTime();
        this.timer = setInterval(() => {
          this.playedTime = this.reformat_time(player.media.currentTime);
        }, 500);
      }, 100);
    },
    //重新初始播放器
    loadVideoFn: function () {
      const _this = this;
      if (_this.isSupport) {
        _this.hls.loadSource(_this.audio); // CCTV1直播源
        _this.hls.attachMedia(_this.$refs.hlsVideo);
        _this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          //console.log('加载成功');
          _this.$refs.player.play();
        });
        _this.hls.on(Hls.Events.ERROR, (event, data) => {
          // //console.log(event, data);
          // 监听出错事件
          _this.errorMsg = "加载失败";
          //console.log('加载失败', data);
        });
      }
    },
    //下一首
    handleNext() {
      const player = this.$refs.player;
      if (this.playMode == 2) {
        let index = this.sjzb.findIndex(
          (arridlist) => arridlist == this.playIndex
        );
        const nextIndex =
          index + 1 > this.audioList.length - 1
            ? this.sjzb[0]
            : this.sjzb[index + 1];
        this.playIndex = nextIndex;
      } else {
        this.playIndex =
          this.playIndex + 1 >= this.audioList.length ? 0 : this.playIndex + 1;
      }

      this.isPlay = true;
      player.skipForward();
      player.play();
      this.countTime = this.reformat_time(player.media.duration);
      this.timer = setInterval(() => {
        this.playedTime = this.reformat_time(player.media.currentTime);
      }, 500);
    },
    getshuffle() {
      let index = this.sjzb.findIndex(
        (arridlist) => arridlist == this.playIndex
      );
      const nextIndex =
        index + 1 > this.audioList.length - 1
          ? this.sjzb[0]
          : this.sjzb[index + 1];
      return nextIndex;
    },
    //上一首
    handlePrev() {
      const player = this.$refs.player;
      if (this.playMode == 2) {
        let index = this.sjzb.findIndex(
          (arridlist) => arridlist == this.playIndex
        );
        const nextIndex =
          index - 1 < 0
            ? this.sjzb[this.audioList.length - 1]
            : this.sjzb[index - 1];
        this.playIndex = nextIndex;
      } else {
        this.playIndex = this.playIndex - 1 <= 0 ? 0 : this.playIndex - 1;
      }
      this.isPlay = true;
      player.skipBack();
      player.play();
      this.countTime = this.reformat_time(player.media.duration);
      this.startRefreshPlayerTime();
    },
    getPlayerClass() {
      if (this.audioList.length === 0) {
        return "main-box no-song";
      }
      if (this.audioList.length === 1) {
        return "main-box one-song";
      }
      return "main-box";
    },
    handleDelete(index) {
      if (index === this.playIndex) {
        this.stopPlayer();
      }

      this.audioList.splice(index, 1);

      if (this.audioList.length == 0) {
        this.playIndex = 0;
        this.countTime = "00:00";
        this.playedTime = "00:00";
      } else if (this.playIndex >= this.audioList.length) {
        this.playIndex = this.audioList.length - 1;
      }
      var index = this.sjzb.findIndex((item) => {
        if (item == index) {
          return true;
        }
      });
      this.sjzb.splice(index, 1);
      //console.log(this.sjzb)
      localStorage.setItem("playIndex", this.playIndex);
      this.savePlayList();
    },
    handleOk() {
      this.isLogin = true;
      this.visible = false;
    },
    handleCancel() {
      this.visible = false;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="less" scoped>
.aplayer {
  background: none;
  margin: 20px 0 0 0;
  box-shadow: none;
}
/deep/.aplayer.aplayer-withlrc .aplayer-pic {
  display: none;
}
/deep/.aplayer.aplayer-withlrc .aplayer-info {
  margin: 0 0 0 2%;
  padding: 6px 10px 0 2%;
  height: 24px;
}
/deep/.aplayer .aplayer-notice,
/deep/.aplayer .aplayer-list {
  display: none;
}
/deep/.aplayer .aplayer-info .aplayer-music,
/deep/.aplayer.aplayer-withlrc .aplayer-lrc,
/deep/.aplayer .aplayer-info .aplayer-controller .aplayer-time,
/deep/.aplayer
  .aplayer-info
  .aplayer-controller
  .aplayer-bar-wrap
  .aplayer-bar
  .aplayer-played
  .aplayer-thumb
  svg {
  display: none;
}
/deep/.aplayer
  .aplayer-info
  .aplayer-controller
  .aplayer-bar-wrap
  .aplayer-bar {
  background: rgba(235, 87, 87, 0.3);
  height: 4px;
}
/deep/.aplayer
  .aplayer-info
  .aplayer-controller
  .aplayer-bar-wrap
  .aplayer-bar
  .aplayer-loaded {
  height: 4px;
  background: rgba(235, 87, 87, 0.3);
}
/deep/.aplayer
  .aplayer-info
  .aplayer-controller
  .aplayer-bar-wrap
  .aplayer-bar
  .aplayer-played {
  height: 4px;
  background: #eb5757 !important;
}
/deep/.aplayer
  .aplayer-info
  .aplayer-controller
  .aplayer-bar-wrap
  .aplayer-bar
  .aplayer-played
  .aplayer-thumb {
  -webkit-transform: scale(1);
  transform: scale(1);
  background: url("./../assets/images/icon/arc2.png") no-repeat !important;
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  top: 0;
  right: 1px;
  margin-top: -10px;
  &:before {
    position: absolute;
    width: 10px;
    height: 10px;
    content: "";
    top: 7px;
    left: 7px;
    background: url("./../assets/images/icon/arc.png") no-repeat !important;
  }
}
.show-list {
  top: 0.2rem !important;
}
</style>
